import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../Auth/AuthProvider';

interface UnauthorizedRouteProps {
  children: ReactNode;
  redirectTo: string;
}

const UnauthorizedRoute: React.FC<UnauthorizedRouteProps> = ({ children, redirectTo }) => {
  const { isAuthenticated, isAuthInitialized } = useAuth();

  if (!isAuthInitialized) {
    return null;
  }

  return isAuthenticated ? <Navigate to={redirectTo} replace /> : <>{children}</>;
};

export default UnauthorizedRoute;
